import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function Dashboard() {
  const [metrics, setMetrics] = useState({ total: 0, today: 0, last24h: 0, visits: [] });
  const [selectedDate, setSelectedDate] = useState('');

  const fetchMetrics = (date = '') => {
    try {
      const visits = JSON.parse(localStorage.getItem('visits') || '[]');
      let filtered = visits;
      
      if (date) {
        filtered = visits.filter(v => v.timestamp.split('T')[0] === date);
      }
      
      const today = new Date().toISOString().split('T')[0];
      const last24h = new Date(Date.now() - 24 * 60 * 60 * 1000);
      
      const data = {
        total: filtered.length,
        today: visits.filter(v => v.timestamp.split('T')[0] === today).length,
        last24h: visits.filter(v => new Date(v.timestamp) > last24h).length,
        visits: filtered
      };
      
      console.log('Metrics data:', data);
      setMetrics(data);
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
    }
  };

  useEffect(() => {
    fetchMetrics();
    // Auto-refresh every 10 seconds
    const interval = setInterval(fetchMetrics, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleDateFilter = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    fetchMetrics(date);
  };

  const chartData = {
    labels: metrics.visits.map(v => new Date(v.timestamp).toLocaleTimeString()),
    datasets: [{
      label: 'Visits',
      data: metrics.visits.map((_, index) => index + 1),
      borderColor: 'rgb(75, 192, 192)',
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
    }]
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Visit Analytics Dashboard</h1>
      
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>Total Visits</h3>
          <p style={{ fontSize: '24px', margin: 0 }}>{metrics.total}</p>
        </div>
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>Today</h3>
          <p style={{ fontSize: '24px', margin: 0 }}>{metrics.today}</p>
        </div>
        <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
          <h3>Last 24h</h3>
          <p style={{ fontSize: '24px', margin: 0 }}>{metrics.last24h}</p>
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label>Filter by Date: </label>
        <input 
          type="date" 
          value={selectedDate} 
          onChange={handleDateFilter}
          style={{ padding: '5px', marginLeft: '10px' }}
        />
        <button 
          onClick={() => { setSelectedDate(''); fetchMetrics(); }}
          style={{ marginLeft: '10px', padding: '5px 10px' }}
        >
          Clear Filter
        </button>
      </div>

      <div style={{ height: '400px', marginBottom: '20px' }}>
        <Line data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
      </div>
    </div>
  );
}

export default Dashboard;